/**
 * @author lifei
 * 功能：异常捕获或处理
 */

import { Base } from '../base'

type TErrorType = 'promise' | 'error'

export class Exception extends Base {
  constructor() {
    super()
  }

  static {
    Base.register(this)
  }

  /**
   * 功能：抛出异常
   */
  public throw(message: string) {
    return new Error(message)
  }

  /**
   * 功能：启动监听
   */
  public observe = () => {
    window.addEventListener('unhandledrejection', this.unhandledrejection)
    window.addEventListener('error', this.error)
  }

  /**
   * 功能：取消监听
   */
  public unObserve = () => {
    window.removeEventListener('unhandledrejection', this.unhandledrejection)
    window.removeEventListener('error', this.error)
  }

  /**
   * 功能：捕获 rejection 错误事件处理函数
   */
  private unhandledrejection = (e: PromiseRejectionEvent) => {
    console.error('Global rejection caught:', e.reason, e.promise)
    this.handler('promise', e)
    e.preventDefault()
  }

  /**
   * 功能：捕获全局错误事件处理函数
   */
  private error = (e: ErrorEvent) => {
    console.error('Global error caught:', e.message)
    this.handler('error', e)
    return true
  }

  /**
   * 功能：异常上报等
   */
  private handler = (bType: TErrorType, e: PromiseRejectionEvent | ErrorEvent) => {
    // 页面路由，时间，异常信息，接口地址，参数等
    console.log(JSON.stringify({ bType, e }))
  }
}

export const exception = new Exception()
